import Accommodation from "./Accommodation.ts";

export const GetItemFromList = {
    getFromJsonList(items: Array<Accommodation>, id: number) {
        const item = items.find((accommodation) => accommodation.id === id);
        if (!item) return null;

        return new Accommodation(
            item.id,
            item.name,
            item.color,
            item.short_name
        );
    },
};
